import {
	Button,
	Checkbox,
	Form,
	Input,
	Radio,
	Row,
	Select,
	Tooltip,
} from "antd";
import { parse } from "papaparse";
import * as React from "react";
import { useEffect, useState, useReducer } from "react";
import { CSVLink } from "react-csv";
import AuthorizationWrapper from "src/common/AuthorizationWrapper";
import { AdminPermissions } from "src/common/Permissions";
import DropDownInputAnt from "src/components/forms/DropdownInputAnt";
import { DataTable, Page } from "src/components/common";
import FileDropBox from "src/components/common/FileDropBox";
import Spinner from "src/components/common/Spinner";
import { ActionIcon } from "src/components/forms/ActionColumnIconsAndButton";
import OrganizationAPI from "../API/OrganizationAPI";
import DatasetAPI from "../Datasets/DatasetAPI";
import { useApi } from "src/Api/useApi";
import {
	BulkAddUsers,
	BulkAddUsersCertMappings,
	BulkAddUsersRoleMappings,
	BulkAddUsersUser,
	CertificationType,
	ITrainingCourse,
} from "src/@types/ImpiricaPlatformApi";
import { FormComponentProps } from "antd/lib/form";
import _ from "lodash";
import { RadioChangeEvent } from "antd/lib/radio";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import { UserOrganizationsGrid } from "src/components/forms/UserOrganizationsGrid";
import { Icon } from "src/components/icons/Icon";
import { Lock } from "lucide-react";
import OrganizationUsersTrainingCourses from "./OrganizationUsersTrainingCourses";
import ResyncTrainingButton from "./ResyncTrainingButton";
import PickListContext from "src/context/pickListContext";
import { toast } from "react-toastify";

enum UserDetailTypes {
	LOAD_DATA = "LOAD_DATA",
	SAVE_DATA = "SAVE_DATA",
}

type State = {
	datasetList: DatasetDTO[];
	roleList: RoleDTO[];
	impiricaOrg: boolean;
};

const initialState: State = {
	datasetList: [],
	roleList: [],
	impiricaOrg: false,
};

type setLoadAction = {
	type: UserDetailTypes.LOAD_DATA;
	datasetList: DatasetDTO[];
	roleList: RoleDTO[];
	impiricaOrg: boolean;
};

type setSaveAction = {
	type: UserDetailTypes.SAVE_DATA;
};

type UserDetailsActionTypes = setLoadAction | setSaveAction;

const setLoad = (
	datasetList: DatasetDTO[],
	roleList: RoleDTO[],
	impiricaOrg: boolean
): UserDetailsActionTypes => ({
	type: UserDetailTypes.LOAD_DATA,
	datasetList,
	roleList,
	impiricaOrg,
});

const formReducer = (state: State, action: UserDetailsActionTypes) => {
	switch (action.type) {
		case UserDetailTypes.LOAD_DATA:
			const { datasetList, roleList, impiricaOrg } = action;

			return {
				...state,
				datasetList,
				roleList,
				impiricaOrg,
			};
		case UserDetailTypes.SAVE_DATA:
			return {
				...state,
			};
		default:
			return state;
	}
};

interface IIndexedUserState extends OrganizationUserDTO {
	_id: number;
}

interface IOrganizationUserDetailsProps extends FormComponentProps {
	match?: any;
	history?: any;
	setUsernameInTab?: any;
}

interface IUserRoleFormItems extends DatasetRoleItemDTO {
	roleName: string;
	datasetName: string;
}

const OrganizationUserDetails: React.FC<IOrganizationUserDetailsProps> = ({
	match,
	history,
	form,
}) => {
	const [state, dispatch] = useReducer(formReducer, initialState);
	const { datasetList, roleList, impiricaOrg } = state;

	const {
		getFieldValue,
		getFieldsValue,
		getFieldDecorator,
		getFieldsError,
		validateFields,
		setFieldsValue,
	} = form;
	const [editingUser, setEditingUser] = useState<boolean>(false);
	const [datasetRoleItem, setDatasetRoleItem] = useState<DatasetRoleItemDTO>(
		{}
	);
	const [loading, setLoading] = useState<boolean>(false);
	const [noPermission, setNoPermission] = useState<boolean>(false);
	const [userRows, setUserRows] = useState<IIndexedUserState[]>([]);
	const [coreCertification, setCoreCertification] = useState<number>();
	const [careCertification, setCareCertification] = useState<number>();
	const [doreCertification, setDoreCertification] = useState<number>();
	const [dcatCertification, setDcatCertification] = useState<number>();
	const [vitalsLegacy, setVitalsLegacyCertification] = useState<number>();
	const [userRoleFormItems, setUserRoleFormItems] = useState<
		IUserRoleFormItems[]
	>([]);
	const [datasetsWithRoles, setDatasetsWithRoles] = useState<number[]>([]);
	const [generalRoleIds, setGeneralRoleIds] = useState<number[]>([]);
	const [datasetRoleItems, setDatasetRoleItems] = useState<
		DatasetRoleItemDTO[]
	>([]);
	const [trainingCourseList, setTrainingCourseList] = useState<
		ITrainingCourse[]
	>([]);
	const url = {
		organizationId: Number(match.params.organizationId),
		userId: Number(match.params.userId),
	};
	const { usersClient, trainingCourseClient } = useApi();
	const [formIsValid, setFormIsValid] = useState<boolean>(false);
	const [activeButton, setActiveButton] = useState<boolean>();
	const [exceleRATEUser, setExceleRATEUser] = useState<boolean>(false);
	const [driveABLEUser, setDriveABLEUser] = useState<boolean>(false);
	const [userTrainingCourses, setUserTrainingCourses] = useState<number[]>([]);

	const roleFromAnotherOrg = "Role from another Organization";
	const datasetFromAnotherOrg = "Dataset from another Organization";

	const { pickListItems } = React.useContext(PickListContext);

	//get products
	const productTypes = React.useMemo(() => {
		return {
			DCAT: pickListItems.find(
				(x) => x.pickListTypeCode === "Product" && x.code === "DCAT"
			),
			DORE: pickListItems.find(
				(x) => x.pickListTypeCode === "Product" && x.code === "DORE"
			),
			Vitals: pickListItems.find(
				(x) => x.pickListTypeCode === "Product" && x.code === "CARE"
			),
			CORE: pickListItems.find(
				(x) => x.pickListTypeCode === "Product" && x.code === "CORE"
			),
		};
	}, [pickListItems]);

	const optionsWithDisabled = roleList
		.filter((x) => x.roleTypeCode !== "DatasetRoleType")
		.map((x) => ({ label: x.name, value: x.id!.toString() }));

	/** Loads the data for the org for adding or editing users. Then loads the user data if editing a user. */
	const _loadUserData = async () => {
		try {
			setLoading(true);

			let fetchedDatasets: DatasetDTO[] = [];
			if (url.userId > 0) {
				fetchedDatasets = await DatasetAPI.getOrganizationDatasets(
					url.organizationId,
					false,
					false,
					url.userId
				);
			} else {
				fetchedDatasets = await DatasetAPI.getOrganizationDatasets(
					url.organizationId
				);
			}

			const fetchedRoles: RoleDTO[] =
				await OrganizationAPI.getOrganizationRoles({
					id: url.organizationId,
				});

			// If we are editing a user, fetch the user data.
			if (url.userId > 0) {
				let fetchedUsers: IIndexedUserState[] = [];
				let uniqueId = new Date().getTime();
				fetchedUsers = [
					await OrganizationAPI.getOrganizationUser({
						tenantId: url.organizationId,
						userId: url.userId,
					}),
				].map((u, index) => {
					return { ...u, _id: uniqueId + index, isValid: true };
				});
				setUserRows(fetchedUsers);
				setEditingUser(true);
				if (fetchedUsers && fetchedUsers.length > 0) {
					setExceleRATEUser(Boolean(fetchedUsers[0].exceleRATEUser));
					setDriveABLEUser(Boolean(fetchedUsers[0].driveABLEUser));
				}
				_populateEditUserData(fetchedUsers, fetchedRoles, fetchedDatasets);
			} else {
				setEditingUser(false);
			}

			dispatch(setLoad(fetchedDatasets, fetchedRoles, impiricaOrg));

			setLoading(false);
		} catch (e) {
			console.error(e);
			setNoPermission(true);
			throw e;
		}
	};

	const _loadTrainingCourses = async () => {
		setLoading(true);
		try {
			if (trainingCourseClient) {
				const fetchedTrainingCourses =
					await trainingCourseClient.getAllTrainingCourses();
				setTrainingCourseList(fetchedTrainingCourses);
				setLoading(false);
			}
			if (trainingCourseClient && url.userId > 0) {
				_loadUserTrainingCourses();
			}
		} catch (error) {
			console.error(error);
			throw error;
		}
	};

	const _loadUserTrainingCourses = async () => {
		setLoading(true);
		try {
			if (trainingCourseClient) {
				const fetchedUserTrainingCourses =
					await trainingCourseClient.getAllTrainingCoursesForUser(url.userId);
				if (fetchedUserTrainingCourses) {
					setUserTrainingCourses(fetchedUserTrainingCourses);
				}
				setLoading(false);
			}
		} catch (error) {
			console.error(error);
			throw error;
		}
	};

	/** Updates state with user data at users[0] for use in editing the user. */
	const _populateEditUserData = (
		fetchedUsers: OrganizationUserDTO[],
		fetchedRoles: RoleDTO[],
		fetchedDatasets: DatasetDTO[]
	) => {
		if (!fetchedUsers[0]) throw new Error("User is required to edit user.");

		let userEditing = fetchedUsers[0];

		if (userEditing.datasetRoleItems) {
			setUserRoleFormItems(
				userEditing.datasetRoleItems.map((dr) => ({
					...dr,
					roleName: _getRoleName(dr.roleId!, fetchedRoles),
					datasetName: _getDatasetName(dr.datasetId!, fetchedDatasets),
				}))
			);
		}

		if (userEditing.datasetRoleItems) {
			setDatasetsWithRoles(
				userEditing.datasetRoleItems
					.filter((dr) => dr.forCurrentOrg === true)
					.map((r) => r.datasetId!)
			);
			setDatasetRoleItems(userEditing.datasetRoleItems);
		}

		if (userEditing.roleIds) {
			setGeneralRoleIds(userEditing.roleIds);
		} else {
			let updatedUser = { ...userRows[0] };
			updatedUser.roleIds = [];
			setUserRows([updatedUser]);
		}
	};

	/** Gets the name of the role from the provided id. If the id is not in state, returns "Undefined". */
	const _getRoleName = (roleId: number, fetchedRoles: RoleDTO[]): string => {
		const value = fetchedRoles.find((i) => i.id === roleId);
		if (!value || !value.name) {
			return roleFromAnotherOrg;
		}
		return value.name;
	};

	/** Gets the name of a dataset from the provided id. If the id is not in state, returns "Undefined". */
	const _getDatasetName = (
		datasetId: number,
		fetchedDatasets: DatasetDTO[]
	): string => {
		const value = fetchedDatasets.find((i) => i.id === datasetId);
		if (!value || !value.name) {
			return datasetFromAnotherOrg;
		}
		return value.name;
	};

	/** Sets the currently selected role for adding to dataset in state. */
	const _onRoleChanged = (value: number) => {
		const updatedDatasetRole = { ...datasetRoleItem };
		updatedDatasetRole.roleId = value;
		setDatasetRoleItem(updatedDatasetRole);
	};

	/** Sets the currently selected dataset for adding roles to in state. */
	const _onDatasetChanged = (value: number) => {
		const updatedDatasetRoleItem = { ...datasetRoleItem };
		updatedDatasetRoleItem.datasetId = value;
		setDatasetRoleItem(updatedDatasetRoleItem);
	};

	/** Adds the datasetRoleItem in state to datasetRoleItems, then updates users state with datasetRoleItems. */
	const _onAddRoleItem = () => {
		if (
			datasetRoleItems.some(
				(item) =>
					item.datasetId === datasetRoleItem.datasetId &&
					item.roleId === datasetRoleItem.roleId
			)
		) {
			toast.error("Role setting already exists.");
			return;
		}

		if (!datasetRoleItem.datasetId || !datasetRoleItem.roleId) {
			toast.error("Role and Dataset are required to set roles.");
			return;
		}

		// Update dataset role items in state.
		const updatedDatasetRoleItems = [...datasetRoleItems];
		updatedDatasetRoleItems.push({ ...datasetRoleItem });
		setDatasetRoleItems(updatedDatasetRoleItems);

		setUserRoleFormItems(
			updatedDatasetRoleItems.map((dr) => ({
				...dr,
				roleName: _getRoleName(dr.roleId!, roleList),
				datasetName: _getDatasetName(dr.datasetId!, datasetList),
			}))
		);

		const updatedDatasetsWithRoles = [...datasetsWithRoles];
		updatedDatasetsWithRoles.push({ ...datasetRoleItem }.datasetId!);
		setDatasetsWithRoles(updatedDatasetsWithRoles);

		setDatasetRoleItem({});

		_updateUsersDatasetRoles(updatedDatasetRoleItems);
	};

	/** Removes the datasetRoleItem provided from the datasetRoleItems in state. */
	const _onRemoveRoleItem = (removedDatasetRoleItem: DatasetRoleItemDTO) => {
		const updatedRoles = datasetRoleItems.filter(
			(item) => item.datasetId !== removedDatasetRoleItem.datasetId
		);
		setUserRoleFormItems(
			updatedRoles.map((dr) => ({
				...dr,
				roleName: _getRoleName(dr.roleId!, roleList),
				datasetName: _getDatasetName(dr.datasetId!, datasetList),
			}))
		);
		setDatasetsWithRoles(
			datasetsWithRoles.filter((ds) => ds !== removedDatasetRoleItem.datasetId!)
		);
		setDatasetRoleItems(updatedRoles);
		_updateUsersDatasetRoles(updatedRoles);
	};

	/** Sets every users dataset roles to the roles in state. */
	const _updateUsersDatasetRoles = (updatedRoleItems: DatasetRoleItemDTO[]) => {
		let updatedUsers = [...userRows];
		updatedUsers.forEach((user) => {
			user.datasetRoleItems = [...updatedRoleItems];
		});
		setUserRows(updatedUsers);
	};

	const _getActions = (rowInfo: any) => {
		return rowInfo.original.roleName != roleFromAnotherOrg ? (
			<ActionIcon
				onClick={() => _onRemoveRoleItem(rowInfo.original)}
				type="delete"
				title="Delete"
			/>
		) : (
			<Icon icon={Lock} />
		);
	};

	const _datasetRoleItemColumns = [
		{
			Header: <Tooltip title="Role">Role</Tooltip>,
			accessor: "roleName",
		},
		{
			Header: <Tooltip title="Dataset">Dataset</Tooltip>,
			accessor: "datasetName",
		},
		{
			Header: <Tooltip title="Actions">Actions</Tooltip>,
			Cell: (rowInfo: any) => _getActions(rowInfo),
		},
	];

	const excelerateUserDisabled = React.useMemo(() => {
		let coreCert = editingUser
			? userRows[0].coreCertificationId
			: coreCertification;
		if (!coreCert) coreCert = CertificationType.NotCertified;
		let careCert = editingUser
			? userRows[0].careCertificationId
			: careCertification;
		if (!careCert) careCert = CertificationType.NotCertified;

		const hasExceleRATECert =
			coreCert !== CertificationType.NotCertified ||
			careCert !== CertificationType.NotCertified;

		if (hasExceleRATECert) {
			setExceleRATEUser(true);
		}
		return hasExceleRATECert;
	}, [userRows, coreCertification, careCertification, editingUser]);

	const driveableUserDisabled = React.useMemo(() => {
		let doreCert = editingUser
			? userRows[0].doreCertificationId
			: doreCertification;
		if (!doreCert) doreCert = CertificationType.NotCertified;
		let dcatCert = editingUser
			? userRows[0].dcatCertificationId
			: dcatCertification;
		if (!dcatCert) dcatCert = CertificationType.NotCertified;

		const hasDriveABLECert =
			doreCert !== CertificationType.NotCertified ||
			dcatCert !== CertificationType.NotCertified;
		if (hasDriveABLECert) {
			setDriveABLEUser(true);
		}
		return hasDriveABLECert;
	}, [userRows, dcatCertification, doreCertification, editingUser]);

	useEffect(() => {
		validateFields();
		_checkErrors();
	}, [userRows]);

	const _checkErrors = () => {
		const fieldsErrors = getFieldsError();
		// check if any of the values are undefined
		let hasErrors = Object.keys(fieldsErrors).some(
			(field) =>
				fieldsErrors[field] !== undefined && fieldsErrors[field]!.length > 0
		);
		const valid = !hasErrors && userRows.length > 0;

		setFormIsValid(valid);
	};

	const _onCsvDrop = (
		e: React.DragEvent<HTMLDivElement>,
		acceptedFiles: FileList
	) => {
		Array.from(acceptedFiles)
			.filter((file: any) => file.type === "text/csv")
			.forEach(async (file) => {
				const text = await file.text();
				let result = parse<OrganizationUserDTO>(text, {
					header: true,
					skipEmptyLines: true,
				});
				let uniqueId = new Date().getTime();
				setUserRows([
					...userRows,
					...result.data.map<IIndexedUserState>((user, index) => ({
						...user,
						_id: uniqueId + index,
						isValid: true,
					})),
				]);
			});
	};

	const _onAddNewUser = () => {
		const updatedUsers: IIndexedUserState[] = [
			...userRows,
			{
				_id: new Date().getTime(),
			},
		];
		setUserRows(updatedUsers);
	};

	const _onRemoveClick = (user: IIndexedUserState) => {
		const updatedUserRows = [...userRows];
		if (updatedUserRows.length > 1) {
			updatedUserRows.splice(updatedUserRows.indexOf(user), 1);
		}
		setUserRows(updatedUserRows);
	};

	function _onActiveChange(e: RadioChangeEvent) {
		setActiveButton(e.target.value);
		const updatedUser = { ...userRows[0] };
		updatedUser.isActive = e.target.value;
		let updatedUsers = userRows;
		updatedUsers[0] = updatedUser;
		setUserRows(updatedUsers);
	}

	const _onVitalsCertificationChange = (e: any) => {
		console.log(e.target.value);
		setVitalsLegacyCertification(e.target.value);
	};

	const _onCoreCertificationChange = (e: any) => {
		//get from product picklist
		const productId = productTypes.CORE ? productTypes.CORE.id! : -1;
		const certStatus = e.key as CertificationType;

		_updateTrainingFromCert(productId, certStatus);

		if (editingUser) {
			setCoreCertification(e.key);
			let updatedUser = { ...userRows[0] };
			updatedUser.coreCertificationId = e.key;
			let updatedUsers = userRows;
			updatedUsers[0] = updatedUser;
			setUserRows(updatedUsers);
		} else {
			setCoreCertification(e.key);
			let updatedUsers = userRows;
			updatedUsers.forEach((u) => {
				u.coreCertificationId = e.key;
			});
			setUserRows(updatedUsers);
		}
	};

	const _onDoreCertificationChange = (e: any) => {
		//get from product picklist
		const productId = productTypes.DORE ? productTypes.DORE.id! : -1;
		const certStatus = e.key as CertificationType;
		_updateTrainingFromCert(productId, certStatus);

		if (editingUser) {
			setDoreCertification(e.key);
			let updatedUser = { ...userRows[0] };
			updatedUser.doreCertificationId = e.key;
			let updatedUsers = userRows;
			updatedUsers[0] = updatedUser;
			setUserRows(updatedUsers);
		} else {
			setDoreCertification(e.key);
			let updatedUsers = userRows;
			updatedUsers.forEach((u) => {
				u.doreCertificationId = e.key;
			});
			setUserRows(updatedUsers);
		}
	};

	const _onDcatCertificationChange = (e: any) => {
		//get from product picklist
		const productId = productTypes.DCAT ? productTypes.DCAT.id! : -1;
		const certStatus = e.key as CertificationType;
		_updateTrainingFromCert(productId, certStatus);

		if (editingUser) {
			setDcatCertification(e.key);
			let updatedUser = { ...userRows[0] };
			updatedUser.dcatCertificationId = e.key;
			let updatedUsers = userRows;
			updatedUsers[0] = updatedUser;
			setUserRows(updatedUsers);
		} else {
			setDcatCertification(e.key);
			let updatedUsers = userRows;
			updatedUsers.forEach((u) => {
				u.dcatCertificationId = e.key;
			});
			setUserRows(updatedUsers);
		}
	};

	const _updateTrainingFromCert = (
		productId: number,
		certStatus: CertificationType
	) => {
		//if certstatus is trainee or certified (not notcertified) then add training courses for that product
		if (certStatus === CertificationType.NotCertified) return;

		const currentCourses = getFieldValue("trainingCourses") as number[];

		//update currentCourses with all courses in trainingCourses that have enrollment containing productId
		const coursesToAdd = trainingCourseList
			.filter((tc) =>
				(tc.enrollments || []).find((e) => e.productId === productId)
			)
			.map((tc) => tc.id);
		const updatedCourses = _.uniq([...currentCourses, ...coursesToAdd]);

		setFieldsValue({ trainingCourses: updatedCourses });
		setUserTrainingCourses(updatedCourses);
	};

	const _onCareCertificationChange = (e: any) => {
		//get from product picklist
		const productId = productTypes.Vitals ? productTypes.Vitals.id! : -1;
		const certStatus = e.key as CertificationType;
		_updateTrainingFromCert(productId, certStatus);

		if (editingUser) {
			setCareCertification(e.key);
			let updatedUser = { ...userRows[0] };
			updatedUser.careCertificationId = e.key;
			let updatedUsers = userRows;
			updatedUsers[0] = updatedUser;
			setUserRows(updatedUsers);
		} else {
			setCareCertification(e.key);
			let updatedUsers = userRows;
			updatedUsers.forEach((u) => {
				u.careCertificationId = e.key;
			});
			setUserRows(updatedUsers);
		}
	};

	const _onExceleRATEUserChange = (e: any) => {
		setExceleRATEUser(e.target.checked);
	};

	const _onDriveABLEUserChange = (e: any) => {
		setDriveABLEUser(e.target.checked);
	};

	const _onNormalRoleChange = (checkedValues: CheckboxValueType[]) => {
		const roleIds = checkedValues.map((x) => parseInt(x.toString(), 10));
		setGeneralRoleIds(roleIds);
	};

	const _editUser = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		const trainingCourses = getFieldValue("trainingCourses");
		const allFields = getFieldsValue();
		const firstName = Object.keys(allFields)
			.filter((key) => key.startsWith("firstName_"))
			.map((key) => allFields[key]);
		const lastName = Object.keys(allFields)
			.filter((key) => key.startsWith("lastName_"))
			.map((key) => allFields[key]);
		const emails = Object.keys(allFields)
			.filter((key) => key.startsWith("email_"))
			.map((key) => allFields[key]);
		const updatedUser = { ...userRows[0] };
		updatedUser.roleIds = generalRoleIds;
		if (updatedUser.roleIds === undefined) {
			updatedUser.roleIds = [];
		}
		setLoading(true);

		// On backend there're some checking that only allows global admin to update tenant, on front-end the system
		// still need to set organizationId as tenantId in user object otherwise it will always be set default to
		updatedUser.firstName = firstName[0];
		updatedUser.lastName = lastName[0];
		updatedUser.email = emails[0];
		updatedUser.exceleRATEUser = exceleRATEUser;
		updatedUser.driveABLEUser = driveABLEUser;

		let updatedUsers = userRows;
		updatedUsers[0] = updatedUser;
		setUserRows(updatedUsers);

		try {
			let userRsp = await OrganizationAPI.postOrganizationUser(updatedUser);

			const promises = Array<Promise<any>>();

			promises.push(
				OrganizationAPI.putOrganizationUserDetails({
					organizationId: url.organizationId,
					userId: userRows[0].id,
					coreCertificationId: userRows[0].coreCertificationId,
					careCertificationId: userRows[0].careCertificationId,
					doreCertificationId: userRows[0].doreCertificationId,
					dcatCertificationId: userRows[0].dcatCertificationId,
					vitalsCertificationId: userRows[0].vitalsCertificationId,
					exceleRATEUser: userRows[0].exceleRATEUser,
					driveABLEUser: userRows[0].driveABLEUser,
				})
			);

			if (trainingCourseClient) {
				promises.push(
					trainingCourseClient.updateUserTrainingCourses(
						userRows[0].id!,
						trainingCourses
					)
				);
			}

			await Promise.all(promises);

			const actionSuccess = url.userId === -1 ? "added" : "updated";

			setLoading(false);
			toast.success(`Successfully ${actionSuccess} user`);

			if (Number(match.params.userId) <= 0) {
				// redirect back to edit page
				history.push(
					`/admin/organizations/${url.organizationId}/users/${userRsp.id}/details`
				);
			} else {
				history.push(`/admin/organizations/${url.organizationId}/users`);
			}
		} catch (errMsg) {
			const actionFail = url.userId === -1 ? "adding" : "updating";
			setLoading(false);
			toast.error(`Failed ${actionFail} user - ${errMsg}`);
		}
	};

	const _handleErrors = async (
		errorEmails: string[],
		firstName: any[],
		lastName: any[],
		emails: any[]
	) => {
		errorEmails.forEach((email) => {
			toast.warning("Error saving...", {
				closeButton: true,
			});
		});

		const filteredUsers = firstName.map((fName: string, index: number) => {
			if (emails.find((x) => x === emails[index])) {
				const errorUser: IIndexedUserState = {
					_id: index,
					firstName: fName,
					lastName: lastName[index] as string,
					email: emails[index] as string,
				};
				return errorUser;
			} else {
				return;
			}
		});

		setUserRows(filteredUsers as IIndexedUserState[]);
	};

	const _submitBulkUsers = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		const trainingCourses = getFieldValue("trainingCourses");
		setUserTrainingCourses(trainingCourses);

		const allFields = getFieldsValue();

		const firstName = Object.keys(allFields)
			.filter((key) => key.startsWith("firstName_"))
			.map((key) => allFields[key].trim());
		const lastName = Object.keys(allFields)
			.filter((key) => key.startsWith("lastName_"))
			.map((key) => allFields[key].trim());
		const emails = Object.keys(allFields)
			.filter((key) => key.startsWith("email_"))
			.map((key) => allFields[key].trim());
		// get distinct emails
		const distinctEmail = _(emails).uniq();
		if (emails.length !== distinctEmail.size()) {
			toast.error("Duplicate emails exists in the list");
			return;
		}

		for (let email of emails) {
			const dupeEmail = await OrganizationAPI.getOrganizationEmailExists({
				email: encodeURIComponent(email),
			});
			if (dupeEmail) {
				toast.error(`A user with the email ${email} already exists`);
				return;
			}
		}

		const users = firstName.map((fName: string, index: number) => {
			return new BulkAddUsersUser({
				firstName: fName,
				lastName: lastName[index] as string,
				emailAddress: emails[index] as string,
			});
		});

		const roleMappings = datasetRoleItems.map((dri) => {
			return new BulkAddUsersRoleMappings({
				datasetId: dri.datasetId!,
				roleId: dri.roleId!,
			});
		});

		const certifications = new BulkAddUsersCertMappings({
			coreCertified: coreCertification,
			vitalsMCertified: careCertification,
			doreCertified: doreCertification,
			dcatCertified: dcatCertification,
		});

		const bulkAddUsers: BulkAddUsers = new BulkAddUsers({
			roleMappings,
			users,
			certifications,
			generalRoleIds,
			exceleRATEUser,
			driveABLEUser,
			courseIds: trainingCourses,
		});

		try {
			setLoading(true);
			const addedUsers = await usersClient!.bulkAddUsers(
				url.organizationId,
				bulkAddUsers
			);

			if (addedUsers) {
				let errors = false;
				let errorEmails: string[] = [];
				for (let key in addedUsers) {
					if (addedUsers[key] === false) {
						errors = true;
						errorEmails.push(key);
					}
				}

				if (errors) {
					_handleErrors(errorEmails, firstName, lastName, emails);
				} else {
					toast.success(`Successfully added user(s)`);
					history.push(`/admin/organizations/${url.organizationId}/users`);
				}
				setLoading(false);
			} else {
				setLoading(false);
				toast.error(`Failed adding user(s)`);
			}
		} catch (ex) {
			toast.error(`Failed adding user(s) - ${ex}`);
			setLoading(false);
		}
	};

	useEffect(() => {
		const init = async () => {
			await _loadUserData();
			await _loadTrainingCourses();
		};
		init();
	}, []);

	const csvTemplate = "firstName,lastName,email";

	if (noPermission)
		return (
			<div className="container-fluid">
				<p>Permission denied</p>
			</div>
		);
	if (loading) return <Spinner />;
	return (
		<Page title="User details">
			<div className="container-fluid">
				<Form
					onSubmit={(e: any) => {
						editingUser ? _editUser(e) : _submitBulkUsers(e);
					}}
					onChange={_checkErrors}
				>
					{!editingUser && (
						<div>
							<Row
								type="flex"
								align="middle"
								className="mb-2 justify-content-between"
							>
								<h3 className="m-0">CSV Bulk Add</h3>
								<CSVLink
									data={csvTemplate}
									style={{
										marginLeft: "8px",
										paddingTop: "2px",
										paddingBottom: "2px",
										paddingLeft: "8px",
										paddingRight: "8px",
										fontWeight: "bolder",
									}}
									filename="csv-template.csv"
								>
									Download CSV Template
								</CSVLink>
							</Row>
							<FileDropBox onCsvDrop={_onCsvDrop} />
						</div>
					)}
					<div className="row font-weight-bold">
						<div className="col-3">
							<label htmlFor="firstName">First name</label>
						</div>
						<div className="col-3">
							<label htmlFor="lastName">Last name</label>
						</div>
						<div className="col-3">
							<label htmlFor="email">Email</label>
						</div>
						{editingUser && (
							<div className="col-2">
								<label>Active</label>
							</div>
						)}
						{!editingUser && (
							<div className="col-1">
								<label>Actions</label>
							</div>
						)}
					</div>
					<div>
						{userRows.map((row) => {
							const firstNameField = `firstName_${row._id}`;
							const lastNameField = `lastName_${row._id}`;
							const emailField = `email_${row._id}`;
							return (
								<div className="row d-flex" key={row._id}>
									<div className="form-group col-3">
										<Form.Item>
											<AuthorizationWrapper
												type="disable"
												permissions={[AdminPermissions.EditOrganizationUser]}
											>
												{getFieldDecorator(firstNameField, {
													rules: [
														{
															required: true,
															message: "Please enter a first name",
															whitespace: true,
														},
													],
													initialValue: row.firstName || "",
												})(
													<Input
														placeholder="Please enter a first name"
														maxLength={50}
													/>
												)}
											</AuthorizationWrapper>
										</Form.Item>
									</div>
									<div className="form-group col-3">
										<Form.Item>
											<AuthorizationWrapper
												type="disable"
												permissions={[AdminPermissions.EditOrganizationUser]}
											>
												{getFieldDecorator(lastNameField, {
													rules: [
														{
															required: true,
															message: "Please enter a last name",
															whitespace: true,
														},
													],
													initialValue: row.lastName || "",
												})(
													<Input
														placeholder="please enter a last name"
														maxLength={50}
													/>
												)}
											</AuthorizationWrapper>
										</Form.Item>
									</div>
									<div className="form-group col-3">
										<Form.Item>
											<AuthorizationWrapper
												type="disable"
												permissions={[AdminPermissions.EditOrganizationUser]}
											>
												{getFieldDecorator(emailField, {
													rules: [
														{
															required: true,
															message: "Please enter an email",
														},
														{
															type: "email",
															message: "Please input a valid email",
														},
													],
													initialValue: row.email || "",
												})(
													<Input
														placeholder="please enter an email"
														maxLength={50}
														disabled={editingUser}
													/>
												)}
											</AuthorizationWrapper>
										</Form.Item>
									</div>
									{editingUser && (
										<div className="form-group col-2">
											<Form.Item>
												<AuthorizationWrapper
													type="disable"
													permissions={[AdminPermissions.EditOrganizationUser]}
												>
													<Radio.Group
														name="isActive"
														value={row.isActive}
														onChange={(e) => {
															_onActiveChange(e);
														}}
													>
														<Radio value={true} checked={activeButton}>
															Active
														</Radio>
														<Radio value={false} checked={!activeButton}>
															Inactive
														</Radio>
													</Radio.Group>
												</AuthorizationWrapper>
											</Form.Item>
										</div>
									)}
									{!editingUser && (
										<div className="form-group col-1">
											<Form.Item>
												<ActionIcon
													onClick={() => _onRemoveClick(row)}
													type="delete"
													title="Delete"
												/>
											</Form.Item>
										</div>
									)}
								</div>
							);
						})}
						{!editingUser && (
							<div className="row">
								<Button
									className="btn-primary ml-3 mb-5"
									onClick={_onAddNewUser}
								>
									+ Add Row
								</Button>
							</div>
						)}
					</div>
					<div>
						<div className="row d-flex space-between">
							<div className="flex-column col-8">
								{editingUser && (
									<div>
										<UserOrganizationsGrid
											userId={url.userId}
											orgId={url.organizationId}
										/>
									</div>
								)}
								<div className="border-bottom mb-3">
									<h3>Role settings</h3>
								</div>
								<div className="row">
									<div className="col-12 form-group">
										<label className="w-100">General role settings</label>
										<AuthorizationWrapper
											type="disable"
											permissions={[AdminPermissions.EditOrganizationUser]}
										>
											<Checkbox.Group
												options={optionsWithDisabled}
												onChange={_onNormalRoleChange}
												value={generalRoleIds.map((x) => x.toString())}
											/>
										</AuthorizationWrapper>
									</div>
								</div>
								{!impiricaOrg && (
									<React.Fragment>
										<label className="font-weight-bold">
											Dataset role settings
										</label>
										<DataTable
											data={userRoleFormItems}
											columns={_datasetRoleItemColumns}
											filterable={false}
											showPagination={false}
										/>
										<div className="row">
											<div className="form-group col-5">
												<label>Role</label>
												<Form.Item
													validateStatus={
														datasetRoleItem.roleId ? "success" : ""
													}
													hasFeedback={true}
												>
													<AuthorizationWrapper
														type="disable"
														permissions={[
															AdminPermissions.EditOrganizationUser,
														]}
													>
														<Select
															onChange={_onRoleChanged}
															value={datasetRoleItem.roleId}
														>
															{roleList.map((item) => {
																if (item.roleTypeCode === "DatasetRoleType") {
																	return (
																		<Select.Option
																			key={`${item.id}`}
																			value={item.id}
																		>
																			<span data-id={item.id}>{item.name}</span>
																		</Select.Option>
																	);
																}
																return null;
															})}
														</Select>
													</AuthorizationWrapper>
												</Form.Item>
											</div>
											<div className="form-group col-5">
												<label>Dataset</label>
												<Form.Item
													validateStatus={
														datasetRoleItem.datasetId ? "success" : ""
													}
												>
													<AuthorizationWrapper
														type="disable"
														permissions={[
															AdminPermissions.EditOrganizationUser,
														]}
													>
														<Select
															onChange={_onDatasetChanged}
															value={datasetRoleItem.datasetId}
														>
															{datasetList
																.filter(
																	(dt: DatasetDTO) =>
																		!datasetsWithRoles.includes(dt.id!) &&
																		dt.isActive
																)
																.map((item) => (
																	<Select.Option
																		key={`${item.id}`}
																		value={item.id}
																	>
																		<span data-id={item.id}>{item.name}</span>
																	</Select.Option>
																))}
														</Select>
													</AuthorizationWrapper>
												</Form.Item>
											</div>
											<div className="col-2 form-group d-flex align-items-end">
												<AuthorizationWrapper
													type="disable"
													permissions={[AdminPermissions.EditOrganizationUser]}
												>
													<Button
														className="btn-primary"
														onClick={_onAddRoleItem}
														disabled={
															!(
																datasetRoleItem.datasetId &&
																datasetRoleItem.roleId
															)
														}
													>
														Add
													</Button>
												</AuthorizationWrapper>
											</div>
										</div>
									</React.Fragment>
								)}
							</div>
							<div className="flex-column col-4">
								<div className="border-bottom mb-3">
									<h3>Certifications</h3>
								</div>
								<div className="form-group">
									<label htmlFor="vitals">VITALS (Legacy) Certification</label>
									<Form.Item required={true}>
										<AuthorizationWrapper
											type="disable"
											permissions={[AdminPermissions.EditOrganizationUser]}
										>
											<DropDownInputAnt
												value={
													editingUser
														? userRows[0].vitalsCertificationId
														: vitalsLegacy
												} // product ids
												onChange={_onVitalsCertificationChange}
												placeholder="Choose a Certification Level"
												name="vitalsCertification"
												pickListCode="Certifications"
												disabled={true}
											/>
										</AuthorizationWrapper>
									</Form.Item>
								</div>
								<div className="form-group">
									<label htmlFor="core">CORE Certification</label>
									<Form.Item required={true}>
										<AuthorizationWrapper
											type="disable"
											permissions={[AdminPermissions.EditOrganizationUser]}
										>
											<DropDownInputAnt
												value={
													editingUser
														? userRows[0].coreCertificationId
														: coreCertification
												} // product ids
												onChange={_onCoreCertificationChange}
												placeholder="Choose a Certification Level"
												name="coreCertification"
												pickListCode="Certifications"
											/>
										</AuthorizationWrapper>
									</Form.Item>
								</div>
								<div className="form-group">
									<label htmlFor="care">Vitals Certification</label>
									<Form.Item required={true}>
										<AuthorizationWrapper
											type="disable"
											permissions={[AdminPermissions.EditOrganizationUser]}
										>
											<DropDownInputAnt
												value={
													editingUser
														? userRows[0].careCertificationId
														: careCertification
												} // product ids
												onChange={_onCareCertificationChange}
												placeholder="Choose a Certification Level"
												name="careCertification"
												pickListCode="Certifications"
											/>
										</AuthorizationWrapper>
									</Form.Item>
								</div>
								<div className="form-group">
									<label htmlFor="core">DCAT Certification</label>
									<Form.Item required={true}>
										<AuthorizationWrapper
											type="disable"
											permissions={[AdminPermissions.EditOrganizationUser]}
										>
											<DropDownInputAnt
												value={
													editingUser
														? userRows[0].dcatCertificationId
														: dcatCertification
												} // product ids
												onChange={_onDcatCertificationChange}
												placeholder="Choose a Certification Level"
												name="dcatCertification"
												pickListCode="Certifications"
											/>
										</AuthorizationWrapper>
									</Form.Item>
								</div>
								<div className="form-group">
									<label htmlFor="core">DORE Certification</label>
									<Form.Item required={true}>
										<AuthorizationWrapper
											type="disable"
											permissions={[AdminPermissions.EditOrganizationUser]}
										>
											<DropDownInputAnt
												value={
													editingUser
														? userRows[0].doreCertificationId
														: doreCertification
												} // product ids
												onChange={_onDoreCertificationChange}
												placeholder="Choose a Certification Level"
												name="doreCertification"
												pickListCode="Certifications"
											/>
										</AuthorizationWrapper>
									</Form.Item>
								</div>
								<div className="form-group">
									<Form.Item>
										<AuthorizationWrapper
											type="disable"
											permissions={[AdminPermissions.EditOrganizationUser]}
										>
											<Checkbox
												checked={exceleRATEUser}
												disabled={excelerateUserDisabled}
												onChange={_onExceleRATEUserChange}
											>
												ExceleRATE User
											</Checkbox>
										</AuthorizationWrapper>
									</Form.Item>
								</div>

								<div className="form-group">
									<Form.Item>
										<AuthorizationWrapper
											type="disable"
											permissions={[AdminPermissions.EditOrganizationUser]}
										>
											<Checkbox
												checked={driveABLEUser}
												disabled={driveableUserDisabled}
												onChange={_onDriveABLEUserChange}
											>
												DriveABLE User
											</Checkbox>
										</AuthorizationWrapper>
									</Form.Item>
								</div>
								<div className="border-bottom mb-3 d-flex justify-content-between align-items-center">
									<h3>Training Courses</h3>
									<ResyncTrainingButton
										organizationId={url.organizationId}
										userId={url.userId}
										onSynced={_loadUserTrainingCourses}
									/>
								</div>
								<div className="form-group">
									<Form.Item className="form-group">
										<AuthorizationWrapper
											type="disable"
											permissions={[AdminPermissions.EditOrganizationUser]}
										>
											{form.getFieldDecorator("trainingCourses", {
												initialValue: userTrainingCourses,
												valuePropName: "existingCourses",
											})(
												<OrganizationUsersTrainingCourses
													options={trainingCourseList}
												/>
											)}
										</AuthorizationWrapper>
									</Form.Item>
								</div>
							</div>
						</div>
					</div>
					<AuthorizationWrapper
						type="hide"
						permissions={[AdminPermissions.EditOrganizationUser]}
					>
						<Button
							className="btn-primary"
							type="primary"
							htmlType="submit"
							disabled={!formIsValid}
						>
							Save
						</Button>
					</AuthorizationWrapper>
				</Form>
			</div>
		</Page>
	);
};

export default Form.create<IOrganizationUserDetailsProps>()(
	OrganizationUserDetails
);
